 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "vendors." + {"0":"90d3d6adf5de87d26efa","1":"3f9f4c56306eabbad2c6","2":"331d61530e8d95632f54","3":"60a9c8bbde2f284cace3","4":"b52435a10913401415ed","5":"603705054bc0e20914cb","6":"8ceced912573d96e173a","7":"8569b3c64067bd2a719d","vendors~Comment~ShareComment":"c5c3f58d0d48fbad2e62","vendors~Comment~Survey":"7cd37012b2d6ab511eb8","vendors~Comment~LoginDialog":"0c3d0c3879d2d59057c5","Comment":"0f967c38a0ab2b43bd6b","vendors~Player":"9ce3d3ff795d760b3893","AccountOpening":"deb109a2f84d84ffc68b","BackTopBottom":"093bd7afd98ec0143f54","Caption":"f6b58c0b8a4a40261f96","Copyright":"959cb62b219e50edc8dc","DataBox":"a1bf6a4c0cff2bd80714","Img":"ceb3ef7599d71828a7db","LivePlayer":"7de1b0f87bc0d9d01d69","MoreTabs":"1a2a7c4700343cb19cdd","Nav":"78ab6d1338c8db97ed12","NormalCaption":"fab2446129202256dd50","Offline":"abff62149ab768ca728b","QQShare":"049a54985c5a0a206793","Stick":"9feb28b50756c3cb3f16","Tip":"3e867ebb8684a2271460","ViewMoreLink":"c02d910206c5e5d662b2","WxLaunchApp":"efb6c8bd8314ee36caa0","vendors~Atlas~FiveNavPic~FourNavPic~InformationFlow~MdBanner~ThreeNavPic":"8d0e185c6e7c8464e0d5","Atlas":"26fb95bdfefc4a05d281","FiveNavPic":"ff587486a77d5da655fa","FourNavPic":"ae02ada3888bb8855c6a","vendors~MdBanner":"ed381d3cb5c6777119ca","vendors~BigImage~BigImg~BigTopic~BottomSlides~BrowserGuideLayer~CallupHead~CallupVideoAppHead~HomeFo~464104dc":"747338c76094aaee8557","CallupVideoAppHead":"fe7e63c1a8cefdbe6943","HomeFooter":"870b4d9286ed1dfea845","Hongbao":"478b78b31940b9a5308c","TwoImage":"e1149d8fd96fad36b9a2","ThreeNavPic":"2fc6c6cb026850857f5e","vendors~BigImage~NewsStream~NoImage~OneImage~ThreeImage":"f85f053164afdb41961a","BigImage":"6777673f02f75c3e07ad","NoImage":"f767868bd67946a23566","OneImage":"b52a7c149ac70503fb8d","ThreeImage":"aabaff668c68905377a7","vendors~NewsStream":"55557624707ee716b14a","vendors~BigImg~BigTopic~InformationFlow~SingleTitle~SlideImg~TitleImg~TwoImg":"94df4ecde0b3a5f25815","BigImg":"615a296dddda46b92f11","SingleTitle":"e60eaafcdd5efbe0b70e","SlideImg":"f07079c1a0dd189bf04c","TwoImg":"2fb307e5156faefa1253","vendors~BigTopic~InformationFlow~TitleImg":"cc7276ea4537f3daa91e","InformationFlow":"c8b74ec28917dcba1489","BigTopic":"36ffb2b2d77f071d9c8f","TitleImg":"12e55348a4016e827b8c","vendors~BottomSlides~IndexSlides~NormalSlides~ShareSlides~Slides~UpgradeBottomSlides":"04d72a113ba15fc498f6","NormalSlides":"0c7b2cd247c321d45805","ShareSlides":"d215dc3461e302725bad","vendors~BottomSlides~UpgradeBottomSlides":"15210a4828fbfba7ac0f","UpgradeBottomSlides":"da168d3231b3ea5e4e21","vendors~IndexSlides":"4c55aa0b993eb6f2a658","vendors~BrowserGuideLayer":"2ff8b185dd6b9feb351b","vendors~CallupHead":"e17d2ed1cc29237679e1","vendors~ShareComment":"ee09a40bcc4e720469ec","vendors~Survey":"d58ac20b17b7dbc683ca","vendors~NormalTabs":"8522be37ced907a14781","vendors~WXGuideLayer":"6a32264d78aa15c37f7e","LoginDialog":"94396db2ed550aea9fb1","vendors~MarkTabs":"470cac621319925e5da0","vendors~SimpleGuideLayer":"5187f60f2a5be92a812d","vendors~SlidesTabs":"094d63e8821e2f07b9c1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				if (script.src.indexOf(window.location.origin + '/') !== 0) {
 					script.crossOrigin = "anonymous";
 				}
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://x2.ifengimg.com/fe/shank/content/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
